/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, merge, MonthPaginator, ReferenceMonth, Text } from 'bold-ui'
import moment from 'moment'
import { Dispatch, SetStateAction } from 'react'

import { DateRange } from '../model'

export interface ChartMonthSelectorProps {
  label?: string
  onChange: Dispatch<SetStateAction<DateRange>>
}

export function ChartMonthSelector(props: ChartMonthSelectorProps) {
  const { label, onChange } = props

  const onClick = (newValue: ReferenceMonth) => {
    const newDate = new Date(newValue.year, newValue.month, 1)
    const newInit = moment(newDate).startOf('month')
    const newEnd = moment(newDate).endOf('month')
    onChange(({ init, end, ...rest }) => merge({}, { init: newInit, end: newEnd }, { ...rest }))
  }

  return (
    <HFlow
      hSpacing={0}
      alignItems='center'
      justifyContent='flex-end'
      style={css`
        margin-left: auto;
        line-height: 1.5rem;
      `}
    >
      <Text>{label}:</Text>
      <MonthPaginator
        onChange={onClick}
        formatter={(date, month) => month.format(date).replace('.', '')}
        ghost={true}
        popperPlacement='bottom-end'
      />
    </HFlow>
  )
}

ChartMonthSelector.defaultProps = {
  label: 'Competência',
} as ChartMonthSelectorProps
